"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTwitchEmbedType = exports.ensureEmbedType = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/**
 * Determines whether an arbitrary string is a valid TwitchEmbedType.
 * @param s a string
 * @returns whether s is a TwitchEmbedType
 */
var isTwitchEmbedType = function isTwitchEmbedType(s) {
  return ["channel", "video", "collection"].includes(s);
};
/**
 * Forces a string into TwitchEmbedType. Defaults to "channel" if s is not a valid
 * embed type.
 * @param s any string
 * @return s as a TwitchEmbedType if valid, "channel" otherwise.
 */

exports.isTwitchEmbedType = isTwitchEmbedType;
var ensureEmbedType = function ensureEmbedType(s) {
  return isTwitchEmbedType(s) ? s : "channel";
};
exports.ensureEmbedType = ensureEmbedType;
var TwitchVideoEmbed = function TwitchVideoEmbed(_ref) {
  var _srcParams;
  var embedType = _ref.embedType,
    embedId = _ref.embedId,
    parent = _ref.parent,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? "100%" : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? "100%" : _ref$height,
    _ref$frameBorder = _ref.frameBorder,
    frameBorder = _ref$frameBorder === void 0 ? 0 : _ref$frameBorder,
    _ref$scrolling = _ref.scrolling,
    scrolling = _ref$scrolling === void 0 ? "no" : _ref$scrolling,
    _ref$allowFullScreen = _ref.allowFullScreen,
    allowFullScreen = _ref$allowFullScreen === void 0 ? false : _ref$allowFullScreen,
    _ref$autoPlay = _ref.autoPlay,
    autoPlay = _ref$autoPlay === void 0 ? true : _ref$autoPlay,
    _ref$muted = _ref.muted,
    muted = _ref$muted === void 0 ? false : _ref$muted,
    time = _ref.time;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    hostName = _useState2[0],
    setHostName = _useState2[1];
  (0, _react.useEffect)(function () {
    var _window, _window$location;
    setHostName(parent || ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname));
  }, [parent]); // All parameters that will be sent to twitch.

  var srcParams = (_srcParams = {}, _defineProperty(_srcParams, embedType, embedId), _defineProperty(_srcParams, "parent", hostName), _defineProperty(_srcParams, "autoplay", autoPlay), _defineProperty(_srcParams, "muted", muted), _defineProperty(_srcParams, "time", time), _srcParams);
  var searchString = Object.entries(srcParams).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      v = _ref3[1];
    return v || v === false;
  }).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      k = _ref5[0],
      v = _ref5[1];
    return "".concat(k, "=").concat(v);
  }).join("&");
  var src = "https://player.twitch.tv/?".concat(searchString);
  var title = "twitch embed";
  return hostName ? /*#__PURE__*/_react.default.createElement("iframe", {
    title: title,
    src: src,
    height: height,
    width: width,
    frameBorder: frameBorder,
    scrolling: scrolling,
    allowFullScreen: allowFullScreen
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
var _default = TwitchVideoEmbed;
exports.default = _default;